import {fancybox} from "../components/fancybox";
import {setFancyboxMessage} from "./helpers";
import {capturePopupSave, popupSaved} from "../components/popup-refresh";

//Attributes
const attr = {
    disabled: 'disabled',
    readonly: 'readonly',
};

const completeButtonDelayMs = 1500;

export function processingButton($button) {
    capturePopupSave($button);
    $button.addClass('processing');
    $button.attr(attr.disabled, attr.disabled);
}

export function resetButton($button) {
    $button.removeClass('load-complete processing');
    $button.removeAttr(attr.disabled);
}

export function completeButton($button, message = false, result = {}) {
    const instance = popupSaved($button, result);
    $button.addClass('load-complete');
    $button.removeAttr(attr.disabled);

    window.setTimeout(() => {
        fancybox.closeSelectedFancybox(instance);
        resetButton($button);

        if (message) {
            setFancyboxMessage(message);
        }
    }, completeButtonDelayMs);
}

export function completeButtonWithoutClosing($button, afterComplete) {
    popupSaved($button);
    $button.addClass('load-complete');
    $button.removeAttr(attr.disabled);

    window.setTimeout(() => {
        resetButton($button);

        if (typeof afterComplete === 'function') {
            afterComplete();
        }
    }, completeButtonDelayMs);
}

export function completeButtonAndThen($button, callback) {
    completeButton($button);

    if (typeof callback === 'function') {
        window.setTimeout(() => {
            callback();
        }, completeButtonDelayMs);
    }
}
